import { setElementHtml } from '../../../../helpers/generic-js/dom.js'
import htmlModule from './index.html'

const containerId = 'costsRecordingSettings'

export function showCostRecording () {
  setElementHtml(containerId, htmlModule)
}
